import { useEffect, useState } from 'react';
import PageHeader from '../../../component/PageHeader';
import { AdminSettingsBreadcrumb } from '../../../config/BreadcrumbConfig';
import { observer } from 'mobx-react';
import { Button, Form, Input } from 'antd';
import ListComponent from './components/ListComponent';
import useStore from '../../../store';
import AddComponent from './components/AddComponent';
import EditComponent from './components/EditComponent';
import DeleteComponent from './components/DeleteComponent';

const AdminSettings = observer(() => {
	const [settingAddModal, setSettingAddModal] = useState(false);
	const [settingDeleteModal, setSettingDeleteModal] = useState(false);
	const [settingEditModal, setSettingEditModal] = useState(false);
	const { ADMINSETTINGS } = useStore();

	const AddSettingModal = () => {
		setSettingAddModal(true);
	};

	const closeAddModal = () => {
		setSettingAddModal(false);
	};

	const openDelete = (data) => {
		setSettingDeleteModal(data);
	};

	const closeDeleteModal = () => {
		setSettingDeleteModal(false);
	};

	const openEdit = () => {
		setSettingEditModal(true);
	};

	const closeEditModal = () => {
		setSettingEditModal(false);
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			ADMINSETTINGS.searchValue = text;
			ADMINSETTINGS.setupGrid(ADMINSETTINGS.agGrid);
		}
	};
	useEffect(() => {
		return () => {
			ADMINSETTINGS.searchValue = '';
		};
	}, []);
	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={AdminSettingsBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Button
						key={2}
						type="primary"
						className="addBtn"
						onClick={AddSettingModal}
					>
						Add Settings
					</Button>,
				]}
			/>
			<ListComponent
				openEditModal={openEdit}
				openDeleteModal={openDelete}
			/>
			<AddComponent visible={settingAddModal} onClose={closeAddModal} />
			<EditComponent
				visible={settingEditModal}
				onClose={closeEditModal}
			/>
			<DeleteComponent
				visible={settingDeleteModal}
				onClose={closeDeleteModal}
			/>
		</div>
	);
});

export default AdminSettings;
